module.exports = __webpack_public_path__ + "static/media/in_a_week_sample_8.93daaf02.jpg";